import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageSquare, MapPin } from "lucide-react";
import { api, formatDate, rupiah } from "@/lib/api";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/StatusBadge";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { PageLoader } from "@/components/layout/RequireAuth";
import { EmptyState } from "@/pages/CategoryPage";

const TABS = [["semua", "Semua"], ["menunggu", "Menunggu"], ["diterima", "Diterima"], ["ditolak", "Ditolak"]];

export default function MyQuotes() {
  const [items, setItems] = useState(null);
  const [tab, setTab] = useState("semua");
  useEffect(() => {
    api.get("/provider/quotes").then((r) => setItems(r.data));
  }, []);
  const shown = (items || []).filter((q) => tab === "semua" || q.status === tab);

  return (
    <div className="container-page max-w-5xl py-10 lg:py-14" data-testid="my-quotes-page">
      <p className="eyebrow">Penyedia</p>
      <h1 className="mt-2 text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl">Penawaran Saya</h1>
      <Tabs value={tab} onValueChange={setTab} className="mt-6">
        <TabsList className="rounded-full bg-stone-100 p-1">
          {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} className="rounded-full px-4" data-testid={`quotes-tab-${v}`}>{l}</TabsTrigger>)}
        </TabsList>
      </Tabs>
      <div className="mt-6 space-y-4">
        {items === null ? <PageLoader /> : shown.length === 0 ? (
          <EmptyState testId="my-quotes-empty" title="Belum ada penawaran" desc="Kirim penawaran dari halaman Permintaan Masuk." />
        ) : shown.map((q) => (
          <div key={q.quote_id} className="card-soft flex flex-col gap-4 p-5 sm:p-6 md:flex-row md:items-center" data-testid={`my-quote-${q.quote_id}`}>
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-3">
                <Link to={`/dasbor/permintaan-masuk/${q.request_id}`} className="text-lg font-bold text-stone-900 hover:text-teal-800">{q.request?.category_name}</Link>
                <StatusBadge status={q.status} testId={`my-quote-status-${q.quote_id}`} />
              </div>
              <div className="mt-2 flex flex-wrap gap-x-5 gap-y-1 text-xs text-stone-500">
                <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" /> {q.request?.city_name}</span>
                <span>Dikirim {formatDate(q.created_at)}</span>
                <span>{q.request?.customer_name}</span>
              </div>
            </div>
            <p className="text-2xl font-extrabold text-stone-900" data-testid={`my-quote-price-${q.quote_id}`}>{rupiah(q.price)}</p>
            <div className="flex flex-wrap gap-2">
              {q.status === "diterima" && <WhatsAppButton whatsapp={q.whatsapp} testId={`my-quote-whatsapp-${q.quote_id}`} fallback="Pelanggan belum menambahkan nomor WhatsApp." />}
              {q.thread_id && (
                <Button asChild variant="outline" className="rounded-xl" data-testid={`my-quote-chat-${q.quote_id}`}>
                  <Link to={`/pesan/${q.thread_id}`}><MessageSquare className="mr-2 h-4 w-4" /> Chat
                    {q.unread > 0 && <span className="ml-2 rounded-full bg-teal-700 px-1.5 text-[11px] font-bold text-white">{q.unread}</span>}
                  </Link>
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
